import { BsCheckLg } from "react-icons/bs"
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { linguaT } from "../helpers/linguaT";


function Done({lang}){
    const styles = {
        width: "100vw",
        height: "50vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center"
    }

    return (
        <Box sx={styles}>
          <BsCheckLg size={60} style={{color: "#24b663", marginBottom: 20}} />
          <Typography variant="h5">
            { linguaT("thanks", lang, []) }
          </Typography>
        </Box>
      )
}

export default Done;